import { useNavigate } from "react-router-dom";

import { HoverCard } from "../../components/ui";
import type { AgentBaseModelReference } from "../api/e2e";

function LineageIcon() {
  return (
    <svg viewBox="0 0 16 16" aria-hidden="true">
      <path d="M3.5 2.5v5A2.5 2.5 0 0 0 6 10h6" />
      <path d="m9.5 7.5 2.5 2.5-2.5 2.5" />
    </svg>
  );
}

export default function RunLineageHoverCard({
  ticker,
  companyId,
  baseModel,
  iterationMessage,
}: {
  ticker: string;
  companyId: string;
  baseModel: AgentBaseModelReference;
  iterationMessage: string | null;
}) {
  const navigate = useNavigate();
  const change = iterationMessage?.trim() ?? "";
  const parentPath = `/companies/${encodeURIComponent(companyId)}/models/${encodeURIComponent(baseModel.model_version_id)}`;
  return (
    <HoverCard
      label={`Started from ${ticker} model version ${baseModel.sequence}`}
      trigger={
        <>
          <LineageIcon />
          <span>from v{baseModel.sequence}</span>
        </>
      }
      className="run-lineage-hover__trigger"
      onActivate={() => navigate(parentPath)}
    >
      <div className="run-lineage-hover">
        <span className="run-lineage-hover__eyebrow">Iteration run</span>
        <strong>
          Started from {ticker} model v{baseModel.sequence}
        </strong>
        {change && (
          <div className="run-lineage-hover__change">
            <span>Change requested</span>
            <p>{change}</p>
          </div>
        )}
      </div>
    </HoverCard>
  );
}
